import {Simplex as BaseSimplex} from 'services/sports/default/simplex';
import Action from 'actions';
import {getMapOfLocked} from 'components/organisms/late-swap/helpers';
import RuleBuilder from 'services/simplex/rule-builder';
import {getSimplexUnitName} from 'helpers/simplex-helper';

export default class SimplexClassic extends BaseSimplex {
    max({incomingValues = {}}) {
        return super.max({
            incomingValues: {
                checkIfPlayerOnDoublePosition: true,
            },
        });
    }

    maxRandom({incomingValues = {}}) {
        return super.maxRandom({
            incomingValues: {
                checkIfPlayerOnDoublePosition: true,
            },
        });
    }

    createRulesForPositionOfPlayerThatStaysOnFlex({incomingValues = {}}) {
        const {
            sportConfig,
            lateSwap: {csvLineups},
            playersData: {games, preparedPlayers},
            lineupResolvingProcess,
        } = Action.getState();
        const {unitIdPropName = 'playerId'} = incomingValues;
        const preparedPlayersPool = preparedPlayers.groupedBy.externalId();
        const players = preparedPlayers.groupedBy.allowedPositions();
        const entryId = lineupResolvingProcess.getEntryId();
        const lateswapCsvLineup = csvLineups.getOneByEntryId(entryId);
        const mapOfLocked = getMapOfLocked(
            sportConfig.getConfigProp('positionsOrder', {}),
            lateswapCsvLineup,
            function (player) {
                return games.isPlayerGameLocked(player);
            },
        );

        const combinedPositionsOrderIds = ['G', 'F', 'flex'];

        let rules = [];
        combinedPositionsOrderIds.map((positionOrderId) => {
            if (!mapOfLocked.positions.hasOwnProperty(positionOrderId)) {
                return;
            }

            const playerExternalId = mapOfLocked.positions[positionOrderId];

            if (!preparedPlayersPool.hasOwnProperty(playerExternalId)) {
                return;
            }

            const player = preparedPlayersPool[playerExternalId];

            player.position.map((positionKey) => {
                const position = sportConfig.getPositionByKey(positionKey);

                rules = [...rules, ...createRulesForPosition(position, player)];

                const jointPositionKey = sportConfig.getJointPosition(positionKey);
                if (jointPositionKey) {
                    const position = sportConfig.getPositionByKey(jointPositionKey);

                    rules = [...rules, ...createRulesForJointPosition(position, player)];
                }
            });
        });

        function createRulesForJointPosition(position, excludablePlayer) {
            const rulesForPosition = createRulesForPosition(position, excludablePlayer);

            rulesForPosition.map((rule) => rule.obj--);

            return rulesForPosition;
        }

        function createRulesForPosition(position, excludablePlayer) {
            if (isEmpty(position)) {
                return [];
            }

            const {allowedPositions} = position;
            const simplexUnitNamesRow = {};
            const addedPlayers = [];

            players.map((player) => {
                if (
                    excludablePlayer.getId() === player.getId() ||
                    !inArray(player.position, allowedPositions) ||
                    inArray(player[unitIdPropName], addedPlayers)
                ) {
                    return;
                }

                simplexUnitNamesRow[getSimplexUnitName(player[unitIdPropName])] = 1;

                addedPlayers.push(player[unitIdPropName]);
            });

            if (isEmpty(simplexUnitNamesRow)) {
                return [];
            }

            const rules = [];

            const atLeastRuleBuilder = RuleBuilder.fromAtLeast(position.minPlayers);
            atLeastRuleBuilder.addVars({...simplexUnitNamesRow});
            rules.push(atLeastRuleBuilder.createRule());

            if (!position.maxPlayers) {
                return rules;
            }

            const atMostRuleBuilder = RuleBuilder.fromAtMost(position.maxPlayers);
            atMostRuleBuilder.addVars({...simplexUnitNamesRow});
            rules.push(atMostRuleBuilder.createRule());

            return rules;
        }

        return [...rules];
    }

    subjectToPermanent() {
        const constraints = {
            salary: this.exec('salary', {checkIfPlayerOnDoublePosition: true}, []),
            projectedOwnershipCap: this.exec('projectedOwnership', {checkIfPlayerOnDoublePosition: true}, []),
            projectedOwnershipForce: this.exec('forceOfProjectedOwnership', {checkIfPlayerOnDoublePosition: true}, []),
            positions: this.exec('positions', {unitIdPropName: 'uniqueId'}, ''),
            games: this.exec('games', {checkIfPlayerOnDoublePosition: true}, ''),
            teamNameStacking: this.exec('teamNameStacking', {checkIfPlayerOnDoublePosition: true}, ''),
            keyPlayerStacking: this.exec('keyPlayerStacking', {checkIfPlayerOnDoublePosition: true}, []),
            projectionBoostRule: this.exec('projectionBoostRule', {checkIfPlayerOnDoublePosition: true}, []),
            bound: this.exec('bound', {checkIfPlayerOnDoublePosition: true}, []),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec('playersWhoseGamesAreLocked', {checkIfPlayerOnDoublePosition: true, unitIdPropName: 'uniqueId'}, []),
            createdLineups: this.exec('createdLineups', {checkIfPlayerOnDoublePosition: true}, []),
            multiPositions: this.exec('multiPositions', {}, []),
            exposureMax: this.exec('exposureMax', {checkIfPlayerOnDoublePosition: true}, []),
            exposureMin: this.exec('exposureMin', {checkIfPlayerOnDoublePosition: true}, []),
            playerCombinationStacking: this.exec('playerCombinationStacking', {checkIfPlayerOnDoublePosition: true}, []),
        };

        return {...constraints};
    }
}
